import { render, staticRenderFns } from "./BaseNumberIncrement.vue?vue&type=template&id=20cb0020&scoped=true&"
import script from "./BaseNumberIncrement.vue?vue&type=script&lang=js&"
export * from "./BaseNumberIncrement.vue?vue&type=script&lang=js&"
import style0 from "./BaseNumberIncrement.vue?vue&type=style&index=0&id=20cb0020&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cb0020",
  null
  
)

export default component.exports